const NAME_EXPRESSION = /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆŠŽ∂ð ,.'-]+$/u;
const POSTAL_ZIP_EXPRESSION = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]|^\d{5}([-]?\d{4})?$/;

export { NAME_EXPRESSION, POSTAL_ZIP_EXPRESSION };
